import { render, staticRenderFns } from "./CertificateRecordSpecs.vue?vue&type=template&id=f1111eaa"
import script from "./CertificateRecordSpecs.vue?vue&type=script&lang=js"
export * from "./CertificateRecordSpecs.vue?vue&type=script&lang=js"
import style0 from "./CertificateRecordSpecs.vue?vue&type=style&index=0&id=f1111eaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports